import { SinglePaymentListByApplicationTypeModule } from '@/components/modules/SinglePaymentListByProduct/SinglePaymentListByApplicationType';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { ALL_CORE_APP_ROLES, ALL_CORE_APP_USER_TYPES } from '@/config/config';
import { ApplicationType, PageScheme } from '@/config/types';

export const PAGE_A2A_PAYMENT_LIST: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.A2A_PAYMENT_LIST,
  showIfAllowedProduct: ApplicationType.A2A_PAYMENT,
  schemesByRoles: [
    {
      roles: [...ALL_CORE_APP_ROLES],
      titleTextId: 'A2A_PAYMENTS_LIST',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <SinglePaymentListByApplicationTypeModule
          permissions={{
            view: ALL_CORE_APP_USER_TYPES,
          }}
          applicationType={ApplicationType.A2A_PAYMENT}
        />
      ),
    },
  ],
};
